import styled from 'styled-components';

export const ModlaStatusStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.3);
  z-index: 99;
  .conteiner {
    width: 40%;
    background: rgba(197, 197, 197, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    position: relative;
    .fecharModal {
      position: absolute;
      top: 10px;
      right: 25px;
      font-size: 30px;
      cursor: pointer;
    }
    ul {
      list-style: none;
      padding: 20px;
      width: 100%;
      gap: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      li {
        width: 60%;
        div {
          width: 100%;
          display: flex;
          justify-content: space-between;
          span {
            font-size: 20px;
            font-weight: 600;
            color: rgba(67, 67, 67, 1);
          }
        }
      }
    }
  }
`;

export const ModalAlert = styled.div`
  --alerta-fundo: rgba(67, 83, 89, 0.98);
  --alerta-superficie: rgba(190, 190, 190, 0.1);
  --alerta-superficie-hover: rgba(210, 210, 210, 0.16);
  --alerta-borda: rgba(205, 205, 205, 0.24);
  --alerta-divisor: rgba(205, 205, 205, 0.16);
  --alerta-texto: rgba(245, 242, 240, 0.96);
  --alerta-secundario: rgba(205, 201, 198, 0.78);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  padding: 24px;
  background-color: rgba(26, 34, 37, 0.58);
  backdrop-filter: blur(5px);
  z-index: 99;

  .conteiner {
    width: min(1080px, 100%);
    height: min(820px, 90vh);
    display: grid;
    grid-template-rows: auto auto minmax(0, 1fr) auto;
    color: var(--alerta-texto);
    background: var(--alerta-fundo);
    border: 1px solid var(--alerta-borda);
    border-radius: 16px;
    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.38);
    overflow: hidden;

    .headerModal {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 20px;
      padding: 24px 28px 18px;
      border-bottom: 1px solid var(--alerta-divisor);

      .tituloModal {
        > span {
          color: var(--alerta-secundario);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }

        h2 {
          margin-top: 3px;
          color: var(--alerta-texto);
          font-size: clamp(23px, 3vw, 30px);
          line-height: 1.1;
        }

        p {
          margin-top: 6px;
          color: var(--alerta-secundario);
          font-size: 13px;
        }
      }

      .closeBotao {
        width: 38px;
        height: 38px;
        display: grid;
        flex: 0 0 auto;
        place-items: center;
        color: var(--alerta-secundario);
        background: var(--alerta-superficie);
        border: 1px solid var(--alerta-borda);
        border-radius: 9px;
        cursor: pointer;
        transition: color 160ms ease, background 160ms ease;

        svg {
          font-size: 23px;
        }

        &:hover {
          color: #ffffff;
          background: var(--alerta-superficie-hover);
        }
      }
    }

    .legendaAlertas {
      display: flex;
      align-items: center;
      gap: 18px;
      padding: 12px 28px;
      color: var(--alerta-secundario);
      border-bottom: 1px solid var(--alerta-divisor);
      font-size: 12px;

      span {
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }

      i {
        width: 7px;
        height: 7px;
        background: #a9babf;
        border-radius: 50%;

        &.critico {
          background: #ff6b6b;
        }

        &.atencao {
          background: #fbbf24;
        }
      }
    }

    .listaAlertas {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-height: 0;
      padding: 14px 20px;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: rgba(143, 160, 165, 0.4) transparent;

      .itemAlerta {
        display: grid;
        grid-template-columns: 8px minmax(0, 1fr);
        align-items: center;
        gap: 14px;
        padding: 14px 16px;
        background: var(--alerta-superficie);
        border: 1px solid var(--alerta-divisor);
        border-radius: 10px;

        .alertaIndicador {
          width: 8px;
          height: 8px;
          background: #a9babf;
          border-radius: 50%;
          box-shadow: 0 0 0 5px rgba(169, 186, 191, 0.12);
        }

        &.critico .alertaIndicador {
          background: #ff6b6b;
          box-shadow: 0 0 0 5px rgba(255, 107, 107, 0.1);
        }

        &.atencao .alertaIndicador {
          background: #fbbf24;
          box-shadow: 0 0 0 5px rgba(251, 191, 36, 0.1);
        }

        .alertaMensagem {
          min-width: 0;

          > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            margin-bottom: 4px;
          }

          .alertaTipo {
            color: var(--alerta-secundario);
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.06em;
            text-transform: uppercase;
          }

          time {
            color: var(--alerta-secundario);
            font-size: 12px;
          }

          strong,
          small {
            display: block;
          }

          strong {
            color: var(--alerta-texto);
            font-size: 15px;
            font-weight: 600;
            line-height: 1.3;
          }

          small {
            margin-top: 4px;
            color: var(--alerta-secundario);
            font-size: 12px;
          }
        }
      }

      .estadoLista {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 180px;
        color: var(--alerta-secundario);

        svg {
          font-size: 21px;
        }
      }
    }

    .setasPaginacao {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 14px 28px;
      border-top: 1px solid var(--alerta-divisor);

      .paginaAtual {
        color: var(--alerta-secundario);
        font-size: 12px;
      }

      .disable {
        opacity: 0.35;
        cursor: not-allowed;
      }

      button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        min-width: 104px;
        padding: 8px 12px;
        color: var(--alerta-texto);
        background: var(--alerta-superficie);
        border: 1px solid var(--alerta-borda);
        border-radius: 8px;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 700;
        transition: background 160ms ease;
      }

      button:not(:disabled):hover {
        background: var(--alerta-superficie-hover);
      }
    }
  }

  @media (max-width: 680px) {
    padding: 10px;

    .conteiner {
      height: 94vh;
      border-radius: 12px;

      .headerModal {
        padding: 18px;
      }

      .legendaAlertas {
        gap: 10px;
        padding: 10px 18px;
        overflow-x: auto;
        white-space: nowrap;
      }

      .listaAlertas {
        padding: 10px;

        .itemAlerta {
          padding: 12px;

          .alertaMensagem > div {
            align-items: flex-start;
            flex-direction: column;
            gap: 2px;
          }
        }
      }

      .setasPaginacao {
        padding: 12px;

        button {
          min-width: 40px;

          span {
            display: none;
          }
        }
      }
    }
  }
`;

export const ModalConfirmController = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.4);
  z-index: 99;
  .deleteContact {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 600px;
    max-width: 80%;
    background-color: rgba(18, 18, 20, 0.9);
    border: 2px solid #b2b2b2;
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    h2 {
      color: white;
    }
    div {
      display: flex;
      gap: 15px;
      width: 100%;
      button {
        width: 100%;
        height: 50px;
        font-size: 1rem;
        font-family: 'Inter', sans-serif;
        color: #ffffff;
        border: none;
        background-color: rgba(195, 13, 26, 1);
        border-radius: 8px;
        cursor: pointer;
      }
      .buttonYes {
        background-color: transparent;
        color: rgba(1, 255, 24, 1);
        border: 2px solid rgba(1, 255, 24, 1);
        transition: 1s;
      }
      .buttonYes:hover {
        background-color: rgba(5, 164, 21, 1);
        color: white;
      }
    }
  }
`;

const ModalCreatingUserBase = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.53);
  backdrop-filter: blur(2px);
  z-index: 99;
  .error {
    color: red;
  }
  form {
    border: 2px solid rgba(125, 125, 125, 1);
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 400px;
    max-width: 95%;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0 0px 30px 0 rgba(232, 232, 232, 0.1);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    list-style: none;
    padding: 15px;
    position: relative;
    color: rgba(208, 208, 208, 1);
    .closeModal {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 30px;
      cursor: pointer;
      transition: 0.5s;
      color: rgba(208, 208, 208, 1);
    }
    .closeModal:hover {
      color: rgba(255, 255, 255, 1);
    }
    ul {
      display: flex;
      flex-direction: column;
      gap: 25px;
      list-style: none;
      li {
        display: flex;
        flex-direction: column;
        position: relative;
        label {
          font-weight: 600;
          color: rgb(255, 255, 255);
          max-width: max-content;
          padding: 0px 4px;
          position: absolute;
          top: -10px;
          left: 15px;
          background: rgb(73, 73, 73);
          background: linear-gradient(
            0deg,
            rgba(73, 73, 73, 0) 20%,
            rgba(73, 73, 73, 0.9051995798319328) 30%,
            rgba(237, 237, 237, 0) 80%
          );
          /* opacity: 85%; */
        }
        input {
          padding: 15px 20px;
          border-radius: 15px;
          border: 1px solid black;
          background-color: rgba(106, 106, 106, 0.4);
          box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          color: rgba(255, 255, 255, 1);
        }
        .viewPassword {
          position: absolute;
          right: 10px;
          top: 15px;
          cursor: pointer;
        }
      }
      .redioInput {
        gap: 10px;
        label {
          position: relative;
        }
        .radio-container:checked {
          background-color: black;
          border-color: black;
        }
      }
    }
    button {
      height: 45px;
      border-radius: 10px;
      border: 2px solid rgba(76, 76, 76, 1);
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      color: rgba(255, 255, 255, 1);
      background-color: rgba(106, 106, 106, 0.4);
      transition: 1s;
      box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
      -webkit-box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
    }
    button:hover {
      background-color: rgba(27, 27, 27, 1);
    }
  }
`;

export const ModalCreatingUser = styled(ModalCreatingUserBase)`
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  height: auto;
  max-height: none;
  padding: 18px;
  box-sizing: border-box;
  overflow-y: auto;
  background: rgba(13, 29, 36, 0.74);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  z-index: 9999;

  .error {
    min-height: 15px;
    color: #b84343;
    font-size: 11px;
    font-weight: 700;
  }

  form {
    width: 640px;
    max-width: 100%;
    max-height: calc(100dvh - 36px);
    box-sizing: border-box;
    gap: 17px;
    padding: 26px;
    overflow-y: auto;
    border: 1px solid rgba(88, 117, 129, 0.24);
    border-top: 4px solid #557d8d;
    border-radius: 16px;
    background: #f7f9fa;
    color: #20343d;
    box-shadow: 0 24px 65px rgba(4, 18, 24, 0.34);
    backdrop-filter: none;
    -webkit-backdrop-filter: none;

    .header {
      padding-right: 42px;

      h2 {
        margin: 0;
        color: #1b3039;
        font-size: 27px;
        letter-spacing: -0.4px;
      }
    }

    .modalDescription {
      margin: -8px 0 2px;
      color: #64767e;
      font-size: 14px;
      line-height: 1.4;
    }

    .closeModal {
      top: 17px;
      right: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      background: #e7edef;
      color: #667980;
      font-size: 25px;
      line-height: 1;
      transition: background 0.2s, color 0.2s;

      &:hover {
        background: #d9e3e7;
        color: #20343c;
      }
    }

    ul {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px 14px;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0;
        position: relative;

        &.fullWidth {
          grid-column: 1 / -1;
        }

        > label {
          position: static;
          padding: 0;
          background: none;
          color: #435861;
          font-size: 13px;
          font-weight: 700;
        }

        input:not([type='radio']),
        select {
          width: 100%;
          height: 44px;
          box-sizing: border-box;
          padding: 0 42px 0 12px;
          border: 1px solid #c5d1d6;
          border-radius: 8px;
          outline: none;
          background: white;
          box-shadow: none;
          color: #22343c;
          font-family: inherit;
          font-size: 14px;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            border-color: #587aaf;
            box-shadow: 0 0 0 3px rgba(88, 122, 175, 0.14);
          }
        }

        select {
          padding-right: 36px;
          cursor: pointer;
        }

        .viewPassword {
          top: 36px;
          right: 13px;
          color: #657981;
        }
      }

      .redioInput {
        gap: 8px;
        padding: 12px;
        border: 1px solid #d7e0e4;
        border-radius: 9px;
        background: #eef3f5;

        > label {
          position: static;
          color: #435861;
          font-size: 13px;
          font-weight: 800;
        }

        .radio-container {
          display: flex;
          gap: 18px;

          label {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            position: static;
            padding: 0;
            background: none;
            color: #31464f;
            font-size: 14px;
            cursor: pointer;
          }

          input {
            accent-color: #4c5fb7;
          }
        }
      }
    }

    > button {
      height: 45px;
      border: 1px solid #4358ad;
      border-radius: 9px;
      background: #4c5fb7;
      color: white;
      font-family: inherit;
      font-size: 16px;
      font-weight: 700;
      box-shadow: 0 7px 18px rgba(42, 56, 119, 0.23);
      transition: background 0.2s, transform 0.2s, box-shadow 0.2s;

      &:hover {
        background: #5a6dcc;
        box-shadow: 0 9px 22px rgba(42, 56, 119, 0.3);
        transform: translateY(-1px);
      }
    }
  }

  @media (max-width: 620px) {
    padding: 10px;

    form {
      max-height: calc(100dvh - 20px);
      padding: 22px 17px;

      .header h2 {
        font-size: 23px;
      }

      ul {
        grid-template-columns: minmax(0, 1fr);

        li.fullWidth {
          grid-column: 1;
        }
      }
    }
  }
`;

export const ModalValulaStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.5);
  z-index: 99;
  .conteiner {
    display: flex;
    background-color: rgba(209, 209, 209, 0.95);
    flex-direction: column;
    padding: 20px;
    gap: 20px;
    border-radius: 15px;
    justify-content: center;
    align-items: center;
    .range {
      display: flex;
      gap: 10px;
      width: 70%;
      align-items: center;
      input {
        -webkit-appearance: none;
        width: 100%;
        height: 10px;
        border-radius: 5px;
        background: rgba(74, 74, 74, 1);
        outline: none;

        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: rgba(103, 103, 103, 1);
          cursor: pointer;
        }
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .buttons {
      display: flex;
      gap: 15px;
      button {
        width: 200px;
        height: 35px;
        cursor: pointer;
        border-radius: 5px;
        border: 2px solid rgba(87, 87, 87, 1);
        font-weight: 600;
      }
      .cancel {
        background-color: rgba(87, 87, 87, 1);
        color: rgba(191, 191, 191, 1);
      }
      .cancel:hover {
        border: 2px;
        border: 2px solid rgba(180, 180, 180, 1);
      }
    }
  }
`;

export const ModalCreatingTanque = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background-color: rgba(13, 29, 36, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 99;

  form {
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 520px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 26px;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(88, 117, 129, 0.24);
    border-top: 4px solid #557d8d;
    border-radius: 16px;
    background: #f7f9fa;
    box-shadow: 0 24px 65px rgba(4, 18, 24, 0.32);

    .header {
      padding-right: 42px;

      h2 {
        margin: 0;
        color: #1b3039;
        font-size: 27px;
        letter-spacing: -0.4px;
      }
    }

    .modalDescription {
      margin: -8px 0 2px;
      color: #64767e;
      font-size: 14px;
    }

    .closeModal {
      position: absolute;
      right: 18px;
      top: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      font-size: 25px;
      line-height: 1;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
      color: #667980;
    }

    .closeModal:hover {
      background: #e7edef;
      color: #20343c;
    }

    ul {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px 14px;
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        display: flex;
        flex-direction: column;
        gap: 6px;

        &:first-child,
        &:last-child {
          grid-column: 1 / -1;
        }

        label {
          color: #435861;
          font-size: 13px;
          font-weight: 700;
        }

        input,
        select {
          width: 100%;
          height: 44px;
          box-sizing: border-box;
          padding: 0 12px;
          border: 1px solid #c5d1d6;
          border-radius: 8px;
          outline: none;
          background: white;
          color: #22343c;
          font-size: 14px;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            border-color: #587aaf;
            box-shadow: 0 0 0 3px rgba(88, 122, 175, 0.14);
          }
        }
      }
    }

    > button {
      height: 45px;
      border: 1px solid #4358ad;
      border-radius: 9px;
      background: #4c5fb7;
      color: white;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      box-shadow: 0 7px 18px rgba(42, 56, 119, 0.23);
      transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
    }

    > button:hover {
      background: #5a6dcc;
      box-shadow: 0 9px 22px rgba(42, 56, 119, 0.3);
      transform: translateY(-1px);
    }
  }

  @media (max-width: 560px) {
    form {
      padding: 22px 18px;

      ul {
        grid-template-columns: minmax(0, 1fr);

        li:first-child,
        li:last-child {
          grid-column: 1;
        }
      }
    }
  }
`;

export const ModalDownloadApp = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  z-index: 9999;
  padding: 16px;
  box-sizing: border-box;
  background: rgba(13, 29, 36, 0.74);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);

  .downloadDialog {
    width: 520px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 26px;
    border: 1px solid rgba(88, 117, 129, 0.24);
    border-top: 4px solid #4c5fb7;
    border-radius: 16px;
    background: #f7f9fa;
    box-shadow: 0 24px 65px rgba(4, 18, 24, 0.34);
    animation: download-modal-enter 0.22s ease-out both;
  }

  .downloadHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    padding-bottom: 20px;
    border-bottom: 1px solid #dbe3e7;

    .eyebrow {
      display: block;
      margin-bottom: 6px;
      color: #4c5fb7;
      font-size: 12px;
      font-weight: 800;
      letter-spacing: 0.9px;
      text-transform: uppercase;
    }

    h2 {
      margin: 0;
      color: #1b3039;
      font-size: 27px;
      letter-spacing: -0.4px;
    }

    p {
      margin: 7px 0 0;
      color: #64767e;
      font-size: 14px;
      line-height: 1.45;
    }
  }

  .closeDownload {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #e7edef;
    color: #52666e;
    font-size: 23px;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;

    &:hover {
      background: #d9e3e7;
      color: #1e333c;
    }
  }

  .platformList {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
  }

  .platformOption {
    display: grid;
    grid-template-columns: 48px minmax(0, 1fr) auto;
    align-items: center;
    gap: 14px;
    width: 100%;
    min-height: 76px;
    box-sizing: border-box;
    padding: 12px 14px;
    border: 1px solid #ccd7dc;
    border-radius: 12px;
    background: white;
    color: #20343d;
    text-align: left;
    text-decoration: none;
  }

  .platformIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #e8eeff;
    color: #4c5fb7;
    font-size: 27px;
  }

  .platformText {
    display: flex;
    flex-direction: column;
    gap: 4px;

    strong {
      font-size: 17px;
    }

    small {
      color: #6b7c83;
      font-size: 13px;
    }
  }

  .optionStatus {
    padding: 7px 11px;
    border-radius: 8px;
    background: #4c5fb7;
    color: white;
    font-size: 13px;
    font-weight: 800;
  }

  .androidOption {
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

    &:hover {
      border-color: #7182d0;
      box-shadow: 0 8px 20px rgba(49, 66, 140, 0.15);
      transform: translateY(-1px);
    }
  }

  .iosOption {
    opacity: 0.55;
    cursor: not-allowed;

    .platformIcon {
      background: #e8ecee;
      color: #66777e;
    }

    .optionStatus {
      background: #dfe5e8;
      color: #607178;
    }
  }

  .downloadNotice {
    margin: 17px 0 0;
    color: #73848b;
    font-size: 12px;
    line-height: 1.45;
    text-align: center;
  }

  @keyframes download-modal-enter {
    from {
      opacity: 0;
      transform: translateY(12px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 520px) {
    .downloadDialog {
      padding: 22px 17px;
    }

    .downloadHeader h2 {
      font-size: 23px;
    }

    .platformOption {
      grid-template-columns: 44px minmax(0, 1fr);
    }

    .platformIcon {
      width: 44px;
      height: 44px;
    }

    .optionStatus {
      grid-column: 1 / -1;
      text-align: center;
    }
  }
`;

export const StyledModalVazao = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.3);
  z-index: 10;
  .conteiner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
    gap: 15px;
    width: 600px;
    min-width: 350px;
    height: 250px;
    background-color: aqua;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.5);
    position: relative;
    .inpultDiv {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;
      width: 100%;
      font-weight: 600;
      .inpulVazao {
        width: 50%;
        cursor: pointer;
        -webkit-appearance: none;
        background: transparent;
      }
      /* trilha */
      .inpulVazao::-webkit-slider-runnable-track {
        height: 8px;
        background: #5a5a5a; /* cor da barra */
        border-radius: 5px;
      }

      /* botão */
      .inpulVazao::-webkit-slider-thumb {
        -webkit-appearance: none;
        height: 18px;
        width: 18px;
        border-radius: 50%;
        background: #d6d6d6; /* cor do botão */
        margin-top: -5px;
        cursor: pointer;
      }

      /* Firefox */
      .inpulVazao::-moz-range-track {
        height: 8px;
        background: #4caf50;
        border-radius: 5px;
      }

      .inpulVazao::-moz-range-thumb {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        background: #7c7c7c;
        border: none;
        cursor: pointer;
      }
    }
    .closeModal {
      font-size: 25px;
      position: absolute;
      top: -8px;
      right: -8px;
      color: white;
      background-color: black;
      border-radius: 50%;
      cursor: pointer;
    }
    background: -moz-linear-gradient(
      0deg,
      rgba(140, 140, 140, 0.6) 0%,
      rgba(237, 237, 237, 0.6) 100%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(140, 140, 140, 0.6) 0%,
      rgba(237, 237, 237, 0.6) 100%
    );
    background: linear-gradient(0deg, rgba(140, 140, 140, 0.96) 0%, rgba(237, 237, 237, 0.99) 100%);
    border: 2px solid rgba(57, 57, 57, 1);
    border-radius: 4px;
    button {
      font-size: 18px;
      font-weight: 600;
      max-height: 100%;
      background-color: var(--bgBotao);
      color: black;
      border-radius: 10px;
      border: 1px solid rgb(0, 0, 0);
      padding: 5px 30px;
      cursor: pointer;
    }
  }
`;
